import React, { Component } from "react";
// import profileImage from './images/profile.png';
import Swiper from "swiper";

export default class AnaSayfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      isCollapsed: false,
      isMenuOpen: false,
      activeTab: "tab-1",
    };
  }
  setActiveTab = (tabId) => {
    this.setState({ activeTab: tabId });
  };

  closeMenu = (event) => {
    if (!event.target.closest(".dropdown")) {
      this.setState({ isMenuOpen: false });
    }
  };
  toggleMenu = () => {
    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  };
  handleScroll = () => {
    const scrollTop = window.pageYOffset;
    const isCollapsed = scrollTop > 60;
    this.setState({ isCollapsed });
  };
  componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    document.querySelectorAll("a.page-scroll").forEach((anchor) => {
      anchor.addEventListener("click", this.handleSmoothScroll);
    });

    this.swiper = new Swiper(
      ".image-slider",
      {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        spaceBetween: 30,
        slidesPerView: 5,
        breakpoints: {
          516: { slidesPerView: 1, spaceBetween: 10 },
          767: { slidesPerView: 2, spaceBetween: 20 },
          991: { slidesPerView: 3, spaceBetween: 30 },
          1199: { slidesPerView: 4, spaceBetween: 30 },
        },
      },
      100
    );
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    document.querySelectorAll("a.page-scroll").forEach((anchor) => {
      anchor.removeEventListener("click", this.handleSmoothScroll);
    });
  }

  handleSmoothScroll = (event) => {
    event.preventDefault();

    const target = event.currentTarget.getAttribute("href");
    if (!target) {
      return;
    }

    const targetId = target.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop,
        behavior: "smooth",
      });
    } else {
      console.error(`Hata: '${targetId}' ID'li element bulunamadı!`);
    }
  };

  render() {
    const { loading, isCollapsed, isMenuOpen, activeTab } = this.state;

    return (
      <>
        {loading ? (
          <div className="spinner-wrapper">
            <div className="spinner">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <nav
          className={`navbar navbar-expand-lg navbar-dark ustmenu-default fixed-top ${
            isCollapsed ? "top-nav-collapse" : ""
          }`}
        >
          <div className="container">
            <a className="navbar-brand logo-image" href="/">
              <img src="images/Universalteam.svg" alt="alternative" />
            </a>

            <button
              className="navbar-toggler"
              type="button"
              onClick={this.toggleMenu}
            >
              <span className="ustmenu-ackapa-fw fas fa-bars"></span>
              {/* <span className="ustmenu-ackapa-fw fas fa-times"></span> */}
            </button>

            <div
              className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
              id="navbarsExampleDefault"
            >
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a
                    className="nav-link page-scroll"
                    href="#description"
                    onClick={this.closeMenu}
                  >
                    About <span className="sr-only">(current)</span>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link page-scroll"
                    href="#features"
                    onClick={this.closeMenu}
                  >
                    Features
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link page-scroll"
                    href="#screens"
                    onClick={this.closeMenu}
                  >
                    Screens
                  </a>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle page-scroll"
                    id="navbarDropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Extra
                  </a>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <a className="dropdown-item" href="/privacy-policy">
                      <span className="item-text">Privacy Policy</span>
                    </a>
                  </div>
                </li>
              </ul>
              <span className="nav-item">
                <a
                  className="buton-cizgili-kucuk page-scroll"
                  href="#download"
                  onClick={this.closeMenu}
                >
                  DOWNLOAD
                </a>
              </span>
            </div>
          </div>
        </nav>

        <header className="header">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="metin-kutusu">
                  <h1>Universalteam Mobile App</h1>
                  <p className="buyuk-baslik p-baslik">
                    Universalteam is a team management system developed
                    specifically for Universalteam, the largest team of Tiens
                    Turkey, based on the needs of a large team of 160,000
                    members.
                  </p>
                  <a className="buton-buyuk" href="">
                    <i className="fab fa-apple"></i>DOWNLOAD
                  </a>
                  <a className="buton-buyuk" href="">
                    <i className="fab fa-google-play"></i>DOWNLOAD
                  </a>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="resim-kutusu">
                  <img
                    className="img-fluid"
                    id="anaResim"
                    src="images/profile.png"
                    alt="alternative"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="beyaz-halka">
            <img src="images/beyazhalka.svg" alt="alternative" />
          </div>
          <div className="beyaz-halka-2">
            <img src="images/beyazhalka.svg" alt="alternative" />
          </div>
          <div className="mavi-halka">
            <img src="images/mavihalka.svg" alt="alternative" />
          </div>
          <div className="sari-halka">
            <img src="images/sarihalka.svg" alt="alternative" />
          </div>
          <div className="gr-dia-halka">
            <img src="images/yesilelmas.svg" alt="alternative" />
          </div>
        </header>

        <div className="kart-1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="kart-resmi">
                    <i className="fas fa-users"></i>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">160K+ Users</h5>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi green">
                    <i className="fas fa-code"></i>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">Over 100K+ Code</h5>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi red">
                    <i className="fas fa-cog"></i>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">Manage Your Team</h5>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi yellow">
                    <i className="fas fa-comments"></i>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">Get In Touch</h5>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi blue">
                    <i className="fas fa-rocket"></i>
                  </div>
                  <div className="card-body">
                    <h5 className="card-title">Performance</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="description" className="temel">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="resim-kutusu">
                  <img
                    className="img-fluid"
                    src="images/ekibim.png"
                    alt="alternative"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="metin-kutusu">
                  <h2>
                    Manage your team from mobile phone and monitorize reports.
                  </h2>
                  <p>
                    With our app, you can access and use many useful panels for
                    your team.
                  </p>
                  <ul className="liste-stili li-buyuk-bosluk">
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">
                        Analyse and evaluate your team current status and
                        productivity
                      </div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">
                        More than 10 useful panels for your team
                      </div>
                    </li>
                    <li className="media">
                      <i className="fas fa-square"></i>
                      <div className="media-body">Motivate your team</div>
                    </li>
                  </ul>
                  <a
                    className="genel-buton-solid popup-with-move-anim"
                    href="/"
                  >
                    DOWNLOAD NOW
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tabs">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="tabs-container">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "tab-1" ? "active" : ""
                        }`}
                        onClick={() => {
                          this.setActiveTab("tab-1");
                        }}
                      >
                        <i className="far fa-user"></i> Contacts
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "tab-2" ? "active" : ""
                        }`}
                        onClick={() => {
                          this.setActiveTab("tab-2");
                        }}
                      >
                        <i className="fas fa-globe"></i> Meets
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "tab-3" ? "active" : ""
                        }`}
                        onClick={() => {
                          this.setActiveTab("tab-3");
                        }}
                      >
                        <i className="fas fa-book"></i> Trainings
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <div
                      className={`tab-pane fade ${
                        activeTab === "tab-1" ? "show active" : ""
                      }`}
                    >
                      <p>
                        <strong>Add people</strong> to your contact list and
                        keep track of them.
                      </p>
                      <ul className="liste-stili li-buyuk-bosluk">
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            Add people to your contact list and take notes about
                            them.
                          </div>
                        </li>
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            Schedule a meeting with people from your contact
                            list and receive a meeting notification.
                          </div>
                        </li>
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            Track the growth rates of the list, including system
                            sign-ups and other metrics.
                          </div>
                        </li>
                      </ul>
                      <a className="genel-buton-solid page-scroll" href="">
                        Download
                      </a>
                    </div>

                    <div
                      className={`tab-pane fade ${
                        activeTab === "tab-2" ? "show active" : ""
                      }`}
                    >
                      <p>
                        <strong>Plan meetings effortlessly</strong> with the
                        online meeting scheduling menu.
                      </p>
                      <p>
                        <strong>Flexibility at its best</strong> allows you to
                        plan meetings monthly, yearly, or for a specific date.
                      </p>
                      <p>
                        <strong>Streamline your workflow</strong> with quick
                        entry and detailed entry options.
                      </p>
                      <a className="red" href="/privacy-policy">
                        Privacy Policy {">>"}
                      </a>
                    </div>

                    <div
                      className={`tab-pane fade ${
                        activeTab === "tab-3" ? "show active" : ""
                      }`}
                    >
                      <p>
                        <strong>
                          Explore a comprehensive and rich content hub
                        </strong>{" "}
                        within our training menu.
                      </p>
                      <ul className="liste-stili li-buyuk-bosluk">
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            <strong>Network Marketing Trainings:</strong> Learn
                            the fundamentals of network marketing.
                          </div>
                        </li>
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            <strong>Product Trainings Panel:</strong> Explore
                            detailed descriptions and writings about various
                            products.
                          </div>
                        </li>
                        <li className="media">
                          <i className="far fa-check-square"></i>
                          <div className="media-body">
                            <strong>Personal Development Trainings:</strong>{" "}
                            Access a variety of personal development courses.
                          </div>
                        </li>
                      </ul>
                      <p>
                        <strong>Track your progress</strong> with counters
                        showing how much of the content you’ve completed.
                      </p>
                    </div>
                  </div>
                </div>
                {/* <div className="tabs-container">
                      <ul className="nav nav-tabs" id="cedoTabs" role="tablist">
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            id="nav-tab-1"
                            data-toggle="tab"
                            href="#tab-1"
                            role="tab"
                            aria-controls="tab-1"
                            aria-selected="true"
                          >
                            <i className="far fa-user"></i>Contacts
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="nav-tab-2"
                            data-toggle="tab"
                            href="#tab-2"
                            role="tab"
                            aria-controls="tab-2"
                            aria-selected="false"
                          >
                            <i className="fas fa-globe"></i>Meets
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            id="nav-tab-3"
                            data-toggle="tab"
                            href="#tab-3"
                            role="tab"
                            aria-controls="tab-3"
                            aria-selected="false"
                          >
                            <i className="fas fa-book"></i>Trainings
                          </a>
                        </li>
                      </ul>

                      <div className="tab-content" id="cedoTabsContent">
                        <div
                          className="tab-pane fade show active"
                          id="tab-1"
                          role="tabpanel"
                          aria-labelledby="tab-1"
                        >
                          <p>
                            <strong>Add people</strong> to your contact list and
                            keep track of them.
                          </p>
                          <ul className="liste-stili li-buyuk-bosluk">
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                Add people to your contact list and take notes
                                about them.
                              </div>
                            </li>
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                Schedule a meeting with people from your contact
                                list and receive a meeting notification.
                              </div>
                            </li>
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                Track the growth rates of the list, including
                                system sign-ups and other metrics.
                              </div>
                            </li>
                          </ul>
                          <a className="genel-buton-solid page-scroll" href="">
                            Download
                          </a>
                        </div>

                        <div
                          className="tab-pane fade"
                          id="tab-2"
                          role="tabpanel"
                          aria-labelledby="tab-2"
                        >
                          <p>
                            <strong>Plan meetings effortlessly</strong> with the
                            online meeting scheduling menu. Once a meeting is
                            scheduled, your team receives instant notifications,
                            keeping everyone informed and on track.
                          </p>
                          <p>
                            <strong>Flexibility at its best</strong> allows you
                            to plan meetings monthly, yearly, or for a specific
                            date. Scheduled meetings appear in a timeline, and
                            you can follow them from the panel of your choice.
                          </p>
                          <p>
                            <strong>Streamline your workflow</strong> with quick
                            entry and detailed entry options. Share meeting
                            links instantly with quick entry, or provide
                            comprehensive details using the detailed entry
                            screen. The choice is yours for efficient meeting
                            management.
                          </p>

                          <a className="red" href="privacy-policy.html">
                            Privacy Policy {">>"}
                          </a>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="tab-3"
                          role="tabpanel"
                          aria-labelledby="tab-3"
                        >
                          <p>
                            <strong>
                              Explore a comprehensive and rich content hub
                            </strong>
                            within our training menu, offering in-depth
                            knowledge and resources. The content is divided into
                            three main categories:
                          </p>
                          <ul className="liste-stili li-buyuk-bosluk">
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                <strong>Network Marketing Trainings:</strong>{" "}
                                Learn the fundamentals of network marketing,
                                what it is, and how to effectively apply it to
                                grow your business.
                              </div>
                            </li>
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                <strong>Product Trainings Panel:</strong>{" "}
                                Explore detailed descriptions and writings about
                                various products, helping you understand their
                                features and applications.
                              </div>
                            </li>
                            <li className="media">
                              <i className="far fa-check-square"></i>
                              <div className="media-body">
                                <strong>Personal Development Trainings:</strong>{" "}
                                Access a variety of personal development courses
                                designed to enhance your skills and mindset.
                              </div>
                            </li>
                          </ul>
                          <p>
                            <strong>Track your progress</strong> with counters
                            showing how much of the content you’ve completed,
                            helping you stay motivated and focused as you
                            progress through your learning journey.
                          </p>
                        </div>
                      </div>
                    </div> */}
              </div>
              <div className="col-lg-6">
                <div className="resim-kutusu">
                  <img
                    className="img-fluid"
                    src="images/kontakt.svg"
                    alt="alternative"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="features" className="basic-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2>Special Features</h2>
                <p className="p-baslik">
                  The Universalteam mobile application has been specifically
                  designed to help you easily manage your teams and support your
                  personal development.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <ul className="liste-stili li-buyuk-bosluk first">
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fas fa-tasks fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Tasks</h4>
                      <p>
                        You can assign tasks to your team and check the results.
                      </p>
                    </div>
                  </li>
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x green"></i>
                      <i className="fas fa-chart-line fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Reports and Analysis</h4>
                      <p>
                        You can track all existing panels with detailed reports
                        and analyses, and guide your team.
                      </p>
                    </div>
                  </li>
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x red"></i>
                      <i className="fas fa-cog fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Team System</h4>
                      <p>
                        The team system transfers your team to the digital
                        environment.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className="col-lg-4">
                <img
                  className="img-fluid"
                  src="images/homepage.svg"
                  alt="alternative"
                />
              </div>
              <div className="col-lg-4">
                <ul className="liste-stili li-buyuk-bosluk">
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x yellow"></i>
                      <i className="fas fa-comments fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Online Meets</h4>
                      <p>
                        You can organize online meetings, make announcements,
                        and join them.
                      </p>
                    </div>
                  </li>
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x blue"></i>
                      <i className="fas fa-rocket fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Transportation</h4>
                      <p>
                        With the transportation system, you can travel
                        affordably and safely to events through shared rides.
                      </p>
                    </div>
                  </li>
                  <li className="media">
                    <span className="fa-stack">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fas fa-images fa-stack-1x"></i>
                    </span>
                    <div className="media-body">
                      <h4>Stories</h4>
                      <p>
                        With Stories, you can update about your day and share it
                        with UniversalTeam.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="screens" className="slider">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="slider-container">
                  <div className="swiper-container image-slider">
                    <div className="swiper-wrapper">
                      <div className="swiper-slide">
                        <a
                          href="images/slide1.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide1.png"
                            alt="alternative"
                          />
                        </a>
                      </div>
                      <div className="swiper-slide">
                        <a
                          href="images/slide2.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide2.png"
                            alt="alternative"
                          />
                        </a>
                      </div>
                      <div className="swiper-slide">
                        <a
                          href="images/slide3.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide3.png"
                            alt="alternative"
                          />
                        </a>
                      </div>
                      <div className="swiper-slide">
                        <a
                          href="images/slide4.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide4.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide7.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide7.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide6.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide6.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide7.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide7.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide3.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide3.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide1.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide1.png"
                            alt="alternative"
                          />
                        </a>
                      </div>

                      <div className="swiper-slide">
                        <a
                          href="images/slide2.png"
                          className="popup-link"
                          data-effect="fadeIn"
                        >
                          <img
                            className="img-fluid"
                            src="images/slide2.png"
                            alt="alternative"
                          />
                        </a>
                      </div>
                    </div>

                    <div className="swiper-button-next"></div>
                    <div className="swiper-button-prev"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cards-2">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h2>Developer Comments</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="kart-resmi">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <hr className="testimonial-line" />
                  </div>
                  <div className="card-body">
                    <div className="gelistirici-yorumlari">
                      I had a lot of fun designing the UniversalTeam
                      application.
                    </div>
                    <div className="gelistici-ismi">
                      Zeynep Durmaz - Designer
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <hr className="testimonial-line" />
                  </div>
                  <div className="card-body">
                    <div className="gelistirici-yorumlari">
                      UniversalTeam is a lifestyle.
                    </div>
                    <div className="gelistici-ismi">
                      Ramazan Taha Akdoğan - Developer
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="kart-resmi">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <hr className="testimonial-line" />
                  </div>
                  <div className="card-body">
                    <div className="gelistirici-yorumlari">
                      The digitalization of teams is a major revolution.
                    </div>
                    <div className="gelistici-ismi">
                      Adil Onur Karahan - Developer
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="counter">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div id="counter">
                  <div className="cell">
                    <i className="fas fa-users"></i>
                    <div className="counter-value number-count">160k</div>
                    <p className="counter-info">Happy Users</p>
                  </div>
                  <div className="cell">
                    <i className="fas fa-code green"></i>
                    <div className="counter-value number-count">100</div>
                    <p className="counter-info">Issues Solved</p>
                  </div>
                  <div className="cell">
                    <i className="fas fa-cog red"></i>
                    <div className="counter-value number-count">150</div>
                    <p className="counter-info">Good Reviews</p>
                  </div>

                  <div className="cell">
                    <i className="fas fa-rocket blue"></i>
                    <div className="counter-value number-count">10</div>
                    <p className="counter-info">Balanced Server</p>
                  </div>
                  <div className="cell">
                    <i className="fas fa-calendar-alt yellow"></i>
                    <div className="counter-value number-count">10k</div>
                    <p className="counter-info">Events Scheduled</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="download" className="basic-3">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="resim-kutusu">
                  <img
                    className="img-fluid"
                    src="images/phonenoback.png"
                    alt="alternative"
                  />
                </div>
                <p className="buyuk-baslik">
                  Do you want to manage your team or advance your individual
                  career? Download now!
                </p>
                <a className="buton-buyuk" href="">
                  <i className="fab fa-apple"></i>DOWNLOAD
                </a>
                <a className="buton-buyuk" href="">
                  <i className="fab fa-google-play"></i>DOWNLOAD
                </a>
              </div>
            </div>
          </div>
          <div className="beyaz-halka">
            <img src="images/beyazhalka.svg" alt="alternative" />
          </div>
          <div className="beyaz-halka-2">
            <img src="images/beyazhalka.svg" alt="alternative" />
          </div>
          <div className="mavi-halka">
            <img src="images/mavihalka.svg" alt="alternative" />
          </div>
          <div className="sari-halka">
            <img src="images/sarihalka.svg" alt="alternative" />
          </div>
          <div className="gr-dia-halka">
            <img src="images/yesilelmas.svg" alt="alternative" />
          </div>
        </div>

        <div className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="footer-col first">
                  <h5>About Ut App</h5>
                  <p className="kucuk-baslik">
                    Ut app is designed for team management.
                  </p>
                </div>
                <div className="footer-col second">
                  <h5>Contact Info</h5>
                  <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                    <li className="media">
                      <i className="fas fa-envelope"></i>
                      <div className="media-body">
                        <a href="">workience@gmail.com</a>
                      </div>
                    </li>
                    <li className="media">
                      <i className="fas fa-phone-alt"></i>
                      <div className="media-body">
                        <a href="">+553 462 20 99</a>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="footer-col third">
                  <h5>Value Links</h5>
                  <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-col fourth">
                  <h5>Other Apps</h5>
                  <ul className="liste-stili li-buyuk-bosluk kucuk-baslik">
                    <li>
                      <a href="">Coming Soon..</a>
                    </li>
                  </ul>
                </div>
                <div className="footer-col fourth">
                  <span className="fa-stack">
                    <a href="">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-facebook-f fa-stack-1x"></i>
                    </a>
                  </span>
                  <span className="fa-stack">
                    <a href="">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-twitter fa-stack-1x"></i>
                    </a>
                  </span>
                  <span className="fa-stack">
                    <a href="">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-pinterest-p fa-stack-1x"></i>
                    </a>
                  </span>
                  <span className="fa-stack">
                    <a href="">
                      <i className="fas fa-circle fa-stack-2x"></i>
                      <i className="fab fa-instagram fa-stack-1x"></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <p className="kucuk-baslik">
                  Copyright © 2025
                  <a href="/"> Universalteam</a> - All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>

        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js"></script>
        <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery-easing/1.4.1/jquery.easing.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js"></script>
      </>
    );
  }
}
